import React, { useState } from 'react';
import { Box, Button, MenuItem, TextField, Typography } from '@material-ui/core';
import Modal from '../../components/Modals/Modal';
import { BgvOverrideStatus } from './bgvApi';

const OPTIONS: { value: BgvOverrideStatus; label: string }[] = [
    { value: 'PASS', label: 'Pass (Clear)' },
    { value: 'IN_PROGRESS', label: 'Back to In Progress' },
];

interface Props {
    open: boolean;
    loading: boolean;
    name: string;
    contactNumber: string;
    currentStatus: string;
    onClose: () => void;
    onSubmit: (status: BgvOverrideStatus, reason: string) => void;
}

const OverrideBgvModal: React.FC<Props> = ({ open, loading, name, contactNumber, currentStatus, onClose, onSubmit }) => {
    const [status, setStatus] = useState<BgvOverrideStatus>('PASS');
    const [reason, setReason] = useState('');
    const trimmedReason = reason.trim();

    const actions = [
        <Button key="cancel" onClick={onClose} disabled={loading}>
            Cancel
        </Button>,
        <Button
            key="submit"
            variant="contained"
            style={{ background: '#43419E', color: '#fff', opacity: loading || !trimmedReason ? 0.5 : 1 }}
            disabled={loading || !trimmedReason}
            onClick={() => onSubmit(status, trimmedReason)}
        >
            Override
        </Button>,
    ];

    return (
        <Modal open={open} onClose={onClose} title="Override BGV Status" actions={actions} loading={loading}>
            <Box mb={2}>
                <Typography style={{ fontSize: 14, fontWeight: 700, color: '#14112d' }}>{name || '—'}</Typography>
                <Typography style={{ fontSize: 12, color: '#4c4e64' }}>
                    {contactNumber} · currently {currentStatus}
                </Typography>
            </Box>
            <TextField
                select
                fullWidth
                variant="outlined"
                size="small"
                label="New status"
                value={status}
                onChange={(e) => setStatus(e.target.value as BgvOverrideStatus)}
            >
                {OPTIONS.map((o) => (
                    <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
                ))}
            </TextField>
            <Box mt={2}>
                <TextField
                    fullWidth
                    multiline
                    rows={3}
                    required
                    variant="outlined"
                    label="Reason"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                />
            </Box>
        </Modal>
    );
};

export default OverrideBgvModal;
